// extracted by mini-css-extract-plugin
export default {"root":"MyRevenue_root__wWuZQ","header":"MyRevenue_header__ho9Le"};